import { useShop } from '@/use/shop'
import { ValidateInvoiceCarrier } from '@/api/invoice'
import { carrierTypeOptions } from '@/config/invoice'
import { noEmptyRules, mobileCarrierFormatRules, citizenCertificateFormatRules, mobileCarrierBDVRules } from '@/validation'

const normalizeConfig = (config) => {
  if (typeof config === 'string') {
    return { source: config }
  }
  return config || {}
}

export const useInvoiceCarrier = (config) => {
  const { shopId } = useShop()
  const { source, validateCarrier } = normalizeConfig(config)

  const bdvValidate = async (carrierNum) => {
    if (!validateCarrier && !source) {
      console.warn('[useInvoiceCarrier] Missing source config for carrier validation')
      return { valid: false, message: '載具驗證失敗，請稍後再試' }
    }

    const [res, err] = validateCarrier
      ? await validateCarrier({
        shopId: shopId.value,
        carrierNum,
      })
      : await ValidateInvoiceCarrier({
        shopId: shopId.value,
        carrierNum,
        source,
      })

    if (err || !res) {
      return { valid: false, message: '載具驗證失敗，請稍後再試' }
    }

    return { valid: res.valid, message: res.message }
  }

  const getCarrierNumPlaceholder = (carrierType) => {
    if (carrierType === '0') return '格式：/ 開頭 + 7 碼大寫英數字或 .+- 符號'
    if (carrierType === '1') return '格式：2 碼英文大寫 + 14 碼數字'
    return '請先選擇載具類型'
  }

  const getCarrierNumRules = (carrierType) => {
    if (carrierType === '0') {
      return [noEmptyRules(), ...mobileCarrierFormatRules(), ...mobileCarrierBDVRules(bdvValidate)]
    }
    if (carrierType === '1') {
      return [noEmptyRules(), ...citizenCertificateFormatRules()]
    }
    return [noEmptyRules()]
  }

  return {
    carrierTypeOptions,
    getCarrierNumPlaceholder,
    getCarrierNumRules,
  }
}
